import mockData from './mock';
import { apiToApp } from './serverApi';

export const loadUserData = () => {
  return Promise.resolve(mockData).then(apiToApp);
};

export { apiToApp };
